import { render, staticRenderFns } from "./OrderInput.vue?vue&type=template&id=b1cd39a4"
import script from "./OrderInput.vue?vue&type=script&lang=js"
export * from "./OrderInput.vue?vue&type=script&lang=js"
import style0 from "./OrderInput.vue?vue&type=style&index=0&id=b1cd39a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports